"use client";
import { useId, useCallback } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { handleDetailInfoModalOpened } from "@/src/store/listingDetail";

import LocationIcon from "assets/svg/location_icon_2.svg";

import { priceFormatter } from "helpers/number-formatter";
import { Ga4WithEventParameters } from "src/helpers/google-tag-manager/events/ga4-with-eventparameters";

import Price from "components/common/price";
import Button from "components/common/button";
import PriceTrend from "components/price-trend";
import { LazyImage } from "components/common/lazy-image/LazyImage";

import { runIdle } from "@/src/utils/idle-utils";
import Unit from "@/src/utils/constants/units";

import styles from "./styles.module.css";

const QuickInfo = ({ data, showAkbankBanner }) => {
  const id = useId();

  const {
    location: { city, summary },
    quickInfos,
    priceDetail: { price, currency, trendType, differenceRate, squareMeterPrice, alternativeValue },
    title,
    properties,
  } = data;
  const infoProperty = properties?.map((property) => property);
  const infoPropertyCategory = properties?.find((property) => property.key === "category");

  const dispatch = useDispatch();

  const handleOpenMap = useCallback(() => {
    dispatch(handleDetailInfoModalOpened("map"));

    runIdle(() => {
      Ga4WithEventParameters({
        eventName: "maps",
        eventParameters: { label: "view||konum" },
      });
    }, 1000);
  }, []);

  /* const handleAkbankBannerClick = () => {
    Ga4WithEventParameters({
      eventName: "click_widget",
      eventParameters: { widget: "fiyat-alti||akbank" },
    });
  }; */

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <div className={styles.topWrap}>
          <span className={styles.price}>{price ? <Price price={price} currency={currency} /> : alternativeValue}</span>
          {trendType === "down" && <PriceTrend data={differenceRate} />}
          {/* showAkbankBanner && (
            <>
              <div className={styles.verticalSeperator} />
              <a
                href="https://mza5.tr.adj.st/akbankdirekt?function=609&widget=true&adj_t=1nthqkr3&adj_deep_link=akbankdirekt%3A%2F%2Fsplash%2Ffunction%2F609&adj_fallback=https%3A%2F%2Fwww.akbank.com%2Fbasvuru%2Fmobileappservice%2F%23&adj_redirect_macos=https%3A%2F%2Fwww.akbank.com%2Fbasvuru%2Fmobileappservice%2F%23&adj_campaign=dob_2"
                target="_blank"
                rel="sponsored nofollow noreferrer"
                title="Akbank Avans Fırsatı"
                className={styles.akbankBannnerLink}
                onClick={handleAkbankBannerClick}
              >
                <img
                  src="/assets/images/akbank/229x40.jpg"
                  alt="Akbank Avans Kampanyası"
                  className={styles.akbankBannerSize}
                />
              </a>
            </>
          ) */}
        </div>
        {infoPropertyCategory.value === "Arsa" &&
          infoProperty?.map(
            (property, index) =>
              property.key === "square_meter_price" && (
                <div key={`${id}meter${index}`} className={styles.meterPrice}>
                  {squareMeterPrice !== 0 && `${priceFormatter(squareMeterPrice)} TL/${Unit.M2.name}`}
                </div>
              )
          )}
        {quickInfos && quickInfos.length ? (
          <ul className={styles.quickInfoList}>
            {quickInfos.map((item, index) => (
              <li key={`${id}-${index}`} value={`${item.name}: ${item.value}`}>
                {item.value}
              </li>
            ))}
          </ul>
        ) : null}
        {city?.name && summary && <span className={styles.location}>{`${city.name} - ${summary}`}</span>}
      </div>
      <div className={styles.mapWrap} onClick={handleOpenMap}>
        <div className={styles.mapButton}>
          <div className={styles.mapImage}>
            <LazyImage src="/assets/images/listing-detail-view-map.png" alt={title} />
          </div>
          <Button size="M" shadow>
            <span className={styles.locationIconWrap}>
              <LocationIcon />
            </span>
            Haritada Gör
          </Button>
        </div>
      </div>
    </div>
  );
};

QuickInfo.propTypes = {
  data: PropTypes.any,
  showAkbankBanner: PropTypes.bool,
};

export default QuickInfo;
